import { connect } from 'react-redux';
import SavedForLaterList from './saved-for-later-list';
import { savedForLaterListSelector } from './connect/saved-for-later-list.selector';
import { savedForLaterListDispatcher } from './connect/saved-for-later-list.dispatcher';
export default connect(savedForLaterListSelector, savedForLaterListDispatcher)(SavedForLaterList);